import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useEventQuestions } from '../../../../../../data/hooks/questions/useEventQuestions';
import StartNetworkingStep from '../../../StartNetworkingStep';
import { isQuestionWithMyAnswers } from '../../../../../../data/filters/questions/isQuestionWithMyAnswers';

function StepViewQA(props) {
    const { eventId } = props,
        i18n = useI18n(),
        answeredQuestions = useEventQuestions(eventId, { filter: isQuestionWithMyAnswers });

    return <StartNetworkingStep href={['/events', eventId, 'qa'].join('/')} complete={answeredQuestions.length > 0}>{i18n['start.view_quests']}</StartNetworkingStep>;
}

export default StepViewQA;
